import { useMatch } from "react-router-dom";

import { PARTY_SECTION_PATH } from "@/app/constants/routes";

export const useGetPartyFromUrl = () => {
	const partyRoute = useMatch(PARTY_SECTION_PATH);

	if (!partyRoute) return null;

	const { partyUUID } = partyRoute.params;

	return partyUUID || null;
};
